// extracted by mini-css-extract-plugin
export var animateCircle = "header-banner-module--animate-circle--3kULy";
export var banner = "header-banner-module--banner--nfbwP";
export var bannerBlock = "header-banner-module--bannerBlock--rTV5f";
export var bounce = "header-banner-module--bounce--9OJx5";
export var button = "header-banner-module--button--40zfd";
export var content = "header-banner-module--content--MX3oV";
export var ldsRing = "header-banner-module--lds-ring--sClLn";
export var text = "header-banner-module--text--WVRdP";